// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table.mainTable[data-v-2f5bb728]{width:100%;table-layout:fixed}*[data-v-2f5bb728]{font-size:90%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
